// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root Font Size */
html {
  font-size: 16px;
}

.about {
  margin: 0 5% 0 5%;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.about h1 {
  display: flex;
  width: 100vw;
  justify-content: center;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  margin-top: 5rem;
  margin-bottom: 5rem;
  font-style: italic;
  align-items: center;
}

.about .landing-quote p {
  font-size: 1.75rem;
  text-align: center;
}

.firstParagraph {
  margin-top: 4rem;
}

.about-text {
  font-size: 1.5rem;
  line-height: 1.7;
  text-align: left;
  text-indent: 2rem;
  margin-bottom: 1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .about h1 {
    font-size: 2rem;
  }

  .about-text {
    font-size: 1rem;
  }
}

@media (max-width: 600px) {
  .about h1 {
    font-size: 1.75rem;
  }

  .about-text {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/About.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Root Font Size */\nhtml {\n  font-size: 16px;\n}\n\n.about {\n  margin: 0 5% 0 5%;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.about h1 {\n  display: flex;\n  width: 100vw;\n  justify-content: center;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n  font-style: italic;\n  align-items: center;\n}\n\n.about .landing-quote p {\n  font-size: 1.75rem;\n  text-align: center;\n}\n\n.firstParagraph {\n  margin-top: 4rem;\n}\n\n.about-text {\n  font-size: 1.5rem;\n  line-height: 1.7;\n  text-align: left;\n  text-indent: 2rem;\n  margin-bottom: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .about h1 {\n    font-size: 2rem;\n  }\n\n  .about-text {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .about h1 {\n    font-size: 1.75rem;\n  }\n\n  .about-text {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
